import script from "./VitaCounter.vue?vue&type=script&lang=ts&setup=true"
export * from "./VitaCounter.vue?vue&type=script&lang=ts&setup=true"

import "./VitaCounter.vue?vue&type=style&index=0&id=f820711a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f820711a"]])

export default __exports__